import { OperationCompanyOrderType } from '../models';
import { ServiceResult } from '../models/api-shared.models';
import ApiService from './api-service';

class OperationCompanyOrderTypeService extends ApiService {
  private static classInstance: OperationCompanyOrderTypeService;

  private constructor() {
    super('OperationCompanyOrderType');
  }

  public getCustomerOperationCompanyOrderTypes(customerId: string): ServiceResult<OperationCompanyOrderType[]> {
    return this.get(`${this.baseUrl}/GetCustomerOperationCompanyOrderTypes`, { customerId });
  }

  public static getInstance(): OperationCompanyOrderTypeService {
    if (!this.classInstance) {
      this.classInstance = new OperationCompanyOrderTypeService();
    }
    return this.classInstance;
  }
}

export default OperationCompanyOrderTypeService;
